import axiosClient from "api/axios_client.js";

const apiSendgridCredential = {
  create:    (payload)     => axiosClient.post("/email-management/email-settings/sendgrid-credential/create", payload),
  update:    (id, payload) => axiosClient.put(`/email-management/email-settings/sendgrid-credential/update/${id}`, payload),
  getAll:    (payload)     => axiosClient.post("/email-management/email-settings/sendgrid-credential/get-all", payload),
  getAllData: ()            => axiosClient.get("/email-management/email-settings/sendgrid-credential/get-all"),
  getById:   (id)          => axiosClient.get(`/email-management/email-settings/sendgrid-credential/get-by-id/${id}`),
  delete:    (id)          => axiosClient.delete("/email-management/email-settings/sendgrid-credential/delete", { data: { id } }),
};

export default apiSendgridCredential;
